import { useQuery } from '@tanstack/react-query';
import { apiWorker } from '../api/worker';
import { AuditLog } from '../types';

export const useAuditActions = () => {
  return useQuery<string[]>({
    queryKey: ['audit-actions'],
    queryFn: () => apiWorker.get('/api/audit/actions').then(r => (r.data && Array.isArray(r.data.content)) ? r.data.content : r.data),
  });
};

export const useAuditLogs = (nodeId: string, limit: number = 50) => {
  return useQuery<AuditLog[]>({
    queryKey: ['audit-logs', nodeId, limit],
    queryFn: () => {
      if (nodeId === 'platform-root') return Promise.resolve([]);
      return apiWorker.get(`/api/audit/${nodeId}`, {
        params: { limit, size: limit }
      }).then(r => (r.data && Array.isArray(r.data.content)) ? r.data.content : r.data);
    },
    enabled: !!nodeId && nodeId !== 'platform-root',
  });
};
